/**
 * Udoskonalony skrypt menu mobilnego - usuwa niepotrzebne elementy i naprawia strzałkę powrotu
 */
document.addEventListener('DOMContentLoaded', function() {
  // Najpierw usuń niepotrzebne bannery
  removeUnnecessaryBanners();
  
  // 1. Obsługa przycisku zamykania menu
  const closeButtons = document.querySelectorAll('.halo-sidebar-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('menu_open');
    });
  });
  
  // 2. Obsługa tła przyciemniającego
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('background-overlay')) {
      document.body.classList.remove('menu_open');
    }
  });
  
  // 3. Obsługa rozwijania menu przy kliknięciach w linki menu
  document.addEventListener('click', function(e) {
    const menuLink = e.target.closest('.menu-lv-1__action, .menu-lv-2__action');
    if (menuLink) {
      const menuItem = menuLink.closest('.menu-lv-item');
      if (!menuItem) return;
      
      // Szukaj podmenu
      const submenu = menuItem.querySelector('.header__submenu, .site-nav-sub, .menu-dropdown');
      if (submenu) {
        e.preventDefault();
        submenu.style.display = 'block';
        menuItem.classList.add('is-open');
      }
    }
  });
  
  // 4. Bardzo bezpośrednia obsługa kliknięć we wszystkie możliwe warianty przycisków powrotu
  document.addEventListener('click', function(e) {
    // Sprawdź, czy kliknięto w jakikolwiek element wewnątrz nav-title-mobile
    let clickedElement = e.target;
    let isNavTitleClick = false;
    let navTitleElement = null;
    
    // Sprawdź, czy kliknięcie nastąpiło w lub wewnątrz nav-title-mobile
    while (clickedElement && clickedElement !== document.body) {
      if (clickedElement.classList && clickedElement.classList.contains('nav-title-mobile')) {
        isNavTitleClick = true;
        navTitleElement = clickedElement;
        break;
      }
      clickedElement = clickedElement.parentElement;
    }
    
    // Jeśli kliknięcie było w nav-title-mobile lub jego elementy wewnętrzne
    if (isNavTitleClick) {
      e.preventDefault();
      e.stopPropagation();
      
      // Znajdź podmenu, które zawiera tę nawigację
      const submenu = findParentBySelectors(navTitleElement, ['.header__submenu', '.site-nav-sub', '.menu-dropdown']);
      if (!submenu) return;
      
      // Znajdź element menu, który otworzył to podmenu
      const parentMenuItem = submenu.closest('.menu-lv-item');
      if (!parentMenuItem) return;
      
      // Ukryj podmenu
      submenu.style.display = 'none';
      parentMenuItem.classList.remove('is-open');
    }
  });
  
  // 5. Specjalne traktowanie Longfills i innych specjalnych kategorii z menu-dropdown
  const megaMenuTitles = document.querySelectorAll('.has-megamenu .menu-dropdown .nav-title-mobile');
  megaMenuTitles.forEach(title => {
    title.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Znajdź podmenu (w tym przypadku menu-dropdown)
      const megaMenu = this.closest('.menu-dropdown');
      if (!megaMenu) return;
      
      // Znajdź element menu, który otworzył to podmenu
      const parentMenuItem = megaMenu.closest('.menu-lv-item');
      if (!parentMenuItem) return;
      
      // Ukryj podmenu
      megaMenu.style.display = 'none';
      parentMenuItem.classList.remove('is-open');
    });
  });
  
  // 6. Dodatkowa obsługa dla wszystkich przycisków strzałki w lewo
  document.querySelectorAll('.icon-arrow-nav').forEach(arrow => {
    arrow.parentElement.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Znajdź najbliższe podmenu
      const submenu = findParentBySelectors(this, ['.header__submenu', '.site-nav-sub', '.menu-dropdown']);
      if (!submenu) return;
      
      // Znajdź element menu, który otworzył to podmenu
      const parentMenuItem = submenu.closest('.menu-lv-item');
      if (!parentMenuItem) return;
      
      // Ukryj podmenu
      submenu.style.display = 'none';
      parentMenuItem.classList.remove('is-open');
    });
  });
  
  // Dodaj bardziej zaawansowane style
  const style = document.createElement('style');
  style.textContent = `
    /* Style dla ikon dropdown */
    .menu-lv-item.is-open > .menu-lv-1__action .icon-dropdown, 
    .menu-lv-item.is-open > .menu-lv-2__action .icon-dropdown {
      transform: rotate(90deg);
    }
    
    .icon-dropdown {
      transition: transform 0.3s ease;
    }
    
    /* Style dla przycisków powrotu */
    .nav-title-mobile {
      cursor: pointer;
      padding: 10px 15px;
      border-bottom: 1px solid #e6e6e6;
      background-color: #f9f9f9;
      font-weight: bold;
      display: flex;
      align-items: center;
    }
    
    .nav-title-mobile .icon-dropdown {
      margin-right: 10px;
      cursor: pointer;
      padding: 5px;
      min-width: 30px;
      min-height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .nav-title-mobile svg.icon-arrow-nav {
      width: 15px;
      height: 15px;
    }
    
    /* Ukryj niepotrzebne bannery */
    .menu-dropdown__banner {
      display: none !important;
    }
    
    /* Zwiększenie obszarów klikalnych dla urządzeń dotykowych */
    @media (pointer: coarse) {
      .menu-lv-1__action, 
      .menu-lv-2__action,
      .nav-title-mobile,
      .icon-dropdown,
      .halo-sidebar-close {
        min-height: 44px;
      }
      
      .nav-title-mobile .icon-dropdown {
        min-width: 44px;
        min-height: 44px;
      }
    }
  `;
  document.head.appendChild(style);
  
  // Funkcja pomocnicza do znajdowania rodzica spełniającego jeden z selektorów
  function findParentBySelectors(element, selectors) {
    let currentElement = element;
    while (currentElement && currentElement !== document.body) {
      for (const selector of selectors) {
        if (currentElement.matches(selector)) {
          return currentElement;
        }
      }
      currentElement = currentElement.parentElement;
    }
    return null;
  }
  
  // Funkcja usuwająca niepotrzebne bannery
  function removeUnnecessaryBanners() {
    // Usuń wszystkie bannery w menu mobilnym
    const banners = document.querySelectorAll('.menu-dropdown__banner');
    banners.forEach(banner => {
      banner.parentNode.removeChild(banner);
    });
  }
  
  // 7. MutationObserver do obsługi dynamicznie ładowanych elementów
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            // Usuń bannery w nowo dodanych elementach
            const newBanners = node.querySelectorAll ? node.querySelectorAll('.menu-dropdown__banner') : [];
            newBanners.forEach(banner => {
              banner.parentNode.removeChild(banner);
            });
            
            // Dodaj obsługę dla nowo dodanych przycisków powrotu
            const newArrows = node.querySelectorAll ? node.querySelectorAll('.icon-arrow-nav') : [];
            newArrows.forEach(arrow => {
              arrow.parentElement.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const submenu = findParentBySelectors(this, ['.header__submenu', '.site-nav-sub', '.menu-dropdown']);
                if (!submenu) return;
                
                const parentMenuItem = submenu.closest('.menu-lv-item');
                if (!parentMenuItem) return;
                
                submenu.style.display = 'none';
                parentMenuItem.classList.remove('is-open');
              });
            });
            
            // Dodaj obsługę dla nowo dodanych nagłówków nav-title-mobile
            const newNavTitles = node.querySelectorAll ? node.querySelectorAll('.nav-title-mobile') : [];
            newNavTitles.forEach(navTitle => {
              navTitle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const submenu = findParentBySelectors(this, ['.header__submenu', '.site-nav-sub', '.menu-dropdown']);
                if (!submenu) return;
                
                const parentMenuItem = submenu.closest('.menu-lv-item');
                if (!parentMenuItem) return;
                
                submenu.style.display = 'none';
                parentMenuItem.classList.remove('is-open');
              });
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
});